module.exports = __webpack_public_path__ + "img/wholesaler.bbec9913.jpg";